import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  container: {
    py: 4,
    px: 2,
  },
  title: {
    fontWeight: 'bold',
    mb: 3,
    textAlign: 'center',
  },
  supportCard: {
    mb: 3,
    borderRadius: 2,
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    border: '1px solid',
    borderColor: 'divider',
  },
  cardContent: {
    textAlign: 'center',
    py: 4,
    px: 3,
  },
  iconContainer: {
    mb: 2,
  },
  supportIcon: {
    fontSize: 48,
    color: 'primary.main',
  },
  cardTitle: {
    fontWeight: 'bold',
    mb: 2,
  },
  description: {
    mb: 2,
    color: 'text.primary',
    lineHeight: 1.6,
  },
  subDescription: {
    mb: 3,
    color: 'text.secondary',
    lineHeight: 1.5,
  },
  whatsappButton: {
    borderRadius: 25,
    px: 4,
    py: 1.5,
    fontSize: '1rem',
    fontWeight: 'bold',
    textTransform: 'none',
    backgroundColor: '#25D366',
    '&:hover': {
      backgroundColor: '#1DA851',
    },
  },
  infoSection: {
    p: 2,
    backgroundColor: 'background.paper',
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
  },
  infoText: {
    color: 'text.secondary',
    textAlign: 'center',
    lineHeight: 1.5,
  },
};
